import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Highlight, HighlightType, Icon } from '@node-space/ui-components'
import { CustomerEntityType } from 'types/customers'
import { sentenceCase } from 'utils/utils'

interface CustomerTypeHighlightProps {
  customerType: CustomerEntityType
}

interface CustomerHighlight {
  icon: JSX.Element
  type: HighlightType
}

export const CustomerTypeHighlight = ({ customerType }: CustomerTypeHighlightProps) => {
  const { t } = useTranslation()

  const highlight: CustomerHighlight = useMemo(() => {
    if (customerType === CustomerEntityType.COMPANY) {
      return {
        icon: <Icon name="Building" size="small" />,
        type: 'neutral',
      }
    }

    if (customerType === CustomerEntityType.INDIVIDUAL) {
      return {
        icon: <Icon name="UserCircle" size="small" />,
        type: 'warning',
      }
    }
  }, [customerType])

  const text =
    customerType === CustomerEntityType.COMPANY
      ? t('customers.business')
      : sentenceCase(customerType?.toLowerCase())

  return (
    !!highlight && (
      <Highlight iconElement={highlight?.icon} type={highlight?.type} variant="emphasis">
        {text}
      </Highlight>
    )
  )
}
